import React from 'react';

export function PageHeader({ title, subtitle, actions, children, junto }) {
  const h1 = <h1 className="font-display text-2xl sm:text-3xl font-semibold text-[#13231E] leading-tight" data-testid="page-title">{title}</h1>;
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div>
        {/* `junto`: lo que va al lado del título sin ser parte de él (los
            botones de la ficha del paciente, 14/10/2026): un h1 no lleva
            botones dentro. Sin `junto`, el título de siempre. */}
        {junto ? (
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5" data-testid="page-title-junto">
            {h1}
            {junto}
          </div>
        ) : h1}
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        {children}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pendiente: 'bg-[rgba(46,110,94,0.12)] text-[#13231E] border-[rgba(46,110,94,0.28)]',
    confirmado: 'bg-[rgba(46,110,94,0.10)] text-[#13231E] border-[rgba(46,110,94,0.22)]',
    expirado: 'bg-[rgba(222,222,222,0.55)] text-[rgba(11,18,32,0.78)] border-[rgba(46,110,94,0.14)]',
    cancelado: 'bg-[rgba(222,222,222,0.75)] text-[rgba(11,18,32,0.78)] border-[rgba(46,110,94,0.14)]',
    // Presupuestos (etiquetas automáticas de seguimiento, 2026-08-27)
    draft: 'bg-[rgba(222,222,222,0.55)] text-[rgba(11,18,32,0.78)] border-[rgba(46,110,94,0.14)]',
    sent: 'bg-sky-100 text-sky-900 border-sky-300',
    accepted: 'bg-emerald-100 text-emerald-900 border-emerald-300',
    rejected: 'bg-red-100 text-red-900 border-red-300',
  };
  const labels = {
    draft: 'Borrador', sent: 'Enviado', accepted: 'Aceptado', rejected: 'Rechazado',
    pendiente: 'Borrador', confirmado: 'Aceptado', expirado: 'Caducado', cancelado: 'Cancelado',
    printed: 'Emitida',
  };
  const cls = map[status] || map.pendiente;
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium ${cls}`}>{labels[status] || status}</span>;
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="cjo-card p-10 flex flex-col items-center justify-center text-center">
      {Icon && <Icon className="w-10 h-10 text-[#2E6E5E] mb-3" />}
      <div className="font-display text-lg font-semibold text-[#13231E]">{title}</div>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function MiniStat({ label, value, hint, icon: Icon }) {
  return (
    <div className="cjo-card p-4 sm:p-5">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-muted-foreground font-medium">{label}</div>
          <div className="text-2xl sm:text-3xl font-display font-semibold text-[#13231E] mt-1 tabular-nums">{value}</div>
          {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
        </div>
        {Icon && <div className="w-10 h-10 rounded-lg bg-[rgba(46,110,94,0.12)] flex items-center justify-center"><Icon className="w-5 h-5 text-[#13231E]" /></div>}
      </div>
    </div>
  );
}

export function SectionCard({ title, action, children, className = '' }) {
  return (
    <div className={`cjo-card p-5 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold text-[#13231E] text-base">{title}</h3>
        {action}
      </div>
      {children}
    </div>
  );
}
